import {
  Controller,
} from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    window.addEventListener('offline', () => {
      this.element.showModal();
    });

    window.addEventListener('online', () => {
      this.element.close();
      const gallery = document.getElementById('gallery');
      if (gallery) gallery.reload();
    });
  }
}
